module.exports = __webpack_public_path__ + "img/wx_connect.efb04d1c.png";